import { ArrowRight, MessageCircle, MapPin } from "lucide-react";
import { BUSINESS, waLink } from "../lib/zoco";

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1598013176070-0b458d501b22?auto=format&fit=crop&w=1800&q=90";

export const Hero = () => {
  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="relative pt-12 md:pt-20 pb-16 md:pb-24 overflow-hidden bg-[#F7F1E3]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-6 fade-up">
          <p className="font-sans-z text-[10px] uppercase tracking-[0.32em] font-semibold text-[#034638] mb-7 flex items-center gap-3">
            <span className="inline-block w-8 h-px bg-[#034638]" />
            La Cala del Moral · Málaga
          </p>

          <h1 className="font-display text-6xl md:text-7xl lg:text-8xl tracking-tight text-[#034638] leading-[1.0] mb-8">
            Cercanía,<br />
            calidad <br />
            <span className="italic text-[#0B5A4A]">y sabor.</span>
          </h1>

          <p className="font-sans-z text-base md:text-lg text-[#1A2823]/80 leading-relaxed max-w-xl mb-10">
            Frutería selecta especializada en especias y frutos secos.
            Producto fresco, artesano y de cercanía, servido con la atención
            del mercado de toda la vida.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-10">
            <a
              href={waLink(`Hola ${BUSINESS.name}, me gustaría hacer un pedido.`)}
              target="_blank"
              rel="noreferrer"
              data-testid="hero-whatsapp-cta"
              className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-[#034638] text-white hover:bg-[#0B5A4A] transition-colors duration-300 font-sans-z text-[11px] tracking-[0.22em] uppercase font-semibold"
            >
              <MessageCircle size={16} strokeWidth={2} />
              Pedir por WhatsApp
            </a>
            <a
              href="#productos"
              data-testid="hero-products-cta"
              className="inline-flex items-center justify-center gap-3 px-8 py-4 border border-[#034638] text-[#034638] hover:bg-[#034638]/5 transition-colors duration-300 font-sans-z text-[11px] tracking-[0.22em] uppercase font-semibold"
            >
              Ver productos
              <ArrowRight size={14} strokeWidth={2} />
            </a>
          </div>

          <div className="flex items-center gap-3 text-[#5C6E6A] font-sans-z text-sm">
            <MapPin size={16} strokeWidth={1.6} />
            <span>
              {BUSINESS.address} · {BUSINESS.city}
            </span>
          </div>
        </div>

        <div className="lg:col-span-6 relative fade-up fade-up-delay-2">
          <div className="relative">
            <img
              src={HERO_IMAGE}
              alt="Selección de frutas frescas Zoco Fruits"
              className="w-full h-[480px] md:h-[600px] object-cover"
              data-testid="hero-image"
            />
            <div className="absolute top-6 left-6 md:top-10 md:left-10 w-16 h-16 md:w-20 md:h-20 overflow-hidden">
              <img
                src="/brand/zoco-logo.jpg"
                alt="Zoco Fruits"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="absolute -bottom-6 -left-6 hidden md:block bg-[#F7F1E3] border border-[#D9CFB6] px-6 py-5 max-w-[260px]">
            <p className="font-sans-z text-sm leading-snug text-[#1A2823]">
              <span className="font-semibold text-[#034638]">Zoco</span> — palabra de origen árabe que significa "mercado".
            </p>
          </div>
        </div>
      </div>

      {/* Marquee strip */}
      <div className="mt-20 md:mt-28 border-y border-[#D9CFB6] bg-[#EFE8D6] overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-7 flex flex-wrap items-center justify-center md:justify-between gap-x-8 gap-y-3 font-sans-z text-[10px] uppercase tracking-[0.3em] font-semibold text-[#034638]">
          <span>· Cercanía</span>
          <span>· Calidad</span>
          <span>· Artesanía</span>
          <span className="text-[#5C6E6A]">|</span>
          <span>· Frutas</span>
          <span>· Verduras</span>
          <span>· Especias</span>
          <span>· Frutos secos</span>
          <span>· Frutas deshidratadas</span>
          <span>· Café</span>
          <span>· Miel</span>
          <span>· Quesos</span>
          <span>· Aceitunas y encurtidos</span>
          <span>· Dulces marroquíes</span>
          <span>· Pan cateto</span>
          <span>· Artesanos</span>
          <span>· Cestas</span>
          <span>· Hostelería</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
